import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  getDocumento,
  insertarDocumento,
  actualizarDocumento,
  eliminarDocumento,
} from "../../../services/modules/Documentos"; // Servicios adaptados para Firebase

const Documentos = () => {
  const [documentos, setDocumentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    Nombre: "",
    Descripcion: "",
  });

  useEffect(() => {
    fetchDocumentos();
  }, []);

  const fetchDocumentos = async () => {
    try {
      const data = await getDocumento(); // Llama a Firestore para obtener la lista de documentos
      setDocumentos(data || []);
      console.log(data)
    } catch (err) {
      setError("Error al cargar los documentos.");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (documento = null) => {
    if (documento) {
      setFormData(documento);
    } else {
      setFormData({
        id: null,
        Nombre: "",
        Descripcion: "",
      });
    }
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      if (formData.id) {
        await actualizarDocumento(formData); // Actualiza el documento en Firestore
        console.log(formData.id)
        alert(`Documento "${formData.Nombre}" actualizado.`);
      } else {
        await insertarDocumento(formData); // Inserta un nuevo documento en Firestore
        alert(`Documento "${formData.Nombre}" agregado.`);
      }
      fetchDocumentos();
      handleCloseModal();
    } catch (error) {
      console.error("Error al guardar documento:", error);
      alert("Ocurrió un error al guardar el documento.");
    }
  };

  const handleDelete = async (id) => {
    console.log(id); // Asegúrate de que el ID esté disponible
    if (window.confirm("¿Estás seguro de que deseas eliminar este documento?")) {
      try {
        await eliminarDocumento(id);
        alert("Documento eliminado exitosamente.");
        fetchDocumentos(); // Refresca la lista
      } catch (error) {
        console.error("Error al eliminar documento:", error);
        alert("Ocurrió un error al eliminar el documento.");
      }
    }
  };
  
  const columns = [
    {
      name: "Nombre",
      selector: (row) => row.Nombre,
      sortable: true,
    },
    {
      name: "Descripción",
      selector: (row) => row.Descripcion,
      sortable: true,
    },
    {
      name: "Acciones",
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <IconButton color="primary" onClick={() => handleOpenModal(row)}>
            <EditIcon />
          </IconButton>
          <IconButton color="error" onClick={() => handleDelete(row.id)}>
            <DeleteIcon />
          </IconButton>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#000000",
        color: "#ffffff",
        fontWeight: "bold",
        textAlign: "center",
      },
    },
    rows: {
      style: {
        "&:hover": {
          backgroundColor: "#f0f0f0",
        },
      },
    },
    cells: {
      style: {
        textAlign: "left",
      },
    },
  };

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div style={{ padding: "20px" }}>
      <h1>Documentos</h1>
      <DataTable
        title="Lista Tipos de Documento"
        columns={columns}
        data={documentos}
        pagination
        highlightOnHover
        pointerOnHover
        customStyles={customStyles}
      />
      <Box sx={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
        <Button variant="contained" color="error" onClick={() => alert("Salir del sistema")}>
          Salir
        </Button>
        <Button variant="contained" color="primary" onClick={() => handleOpenModal()}>
          Ingresar Documento
        </Button>
      </Box>
      <Dialog open={open} onClose={handleCloseModal}>
        <DialogTitle>{formData.id ? "Editar Documento" : "Ingresar Documento"}</DialogTitle>
        <DialogContent>
          <TextField
            label="Nombre"
            name="Nombre"
            value={formData.Nombre}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Descripción"
            name="Descripcion"
            value={formData.Descripcion}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} color="primary">
            {formData.id ? "Actualizar" : "Guardar"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Documentos;
